<template>
    <div class="container">
        <div class="section-header text-center">
            <h2>¿Quiénes <span>somos?</span></h2>
            <p>
                {{ quienesdata.description }}
            </p>
        </div>
        <div class="row">
            <div class="clearfix"></div>
            <div class="col-md-6 col-sm-6">
                <div class="about_content row">
                    <div class="col-md-5 col-sm-4 col-xs-4">
                        <div class="about_img">
                            <img src="assets/images/start-up.png" alt="image" />
                        </div>
                    </div>
                    <div class="col-md-7 col-sm-8 col-xs-8">
                        <h3>Nuestra <span>Misión</span></h3>
                        <p>
                            {{quienesdata.mision}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6">
                <div class="about_content row">
                    <div class="col-md-5 col-sm-4 col-xs-4">
                        <div class="about_img">
                            <img src="assets/images/shape.png" alt="image" />
                        </div>
                    </div>
                    <div class="col-md-7 col-sm-8 col-xs-8">
                        <h3>Nuestra <span>Visión</span></h3>
                        <p>
                            {{quienesdata.vision}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['quienesdata']
};
</script>

<style lang="scss" scoped></style>
